import styled, {css} from 'styled-components'

export const StyledHomeCard = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 4}px;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 6}px;
        align-items: flex-start;
        justify-content: space-between;
    `
)

export const StyledHomeCardContent = styled.div(
    ({theme: {spacing}}) => css`
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 6}px;
    `
)

// Bordered content area: holds the notifications list or the empty state
export const StyledActivitiesBox = styled.div(
    ({theme: {spacing, palette}}) => css`
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: ${spacing * 4}px;
        border: 1px solid ${palette.neutral['200']};
        border-radius: 12px;
    `
)

// Fills the remaining box height so the empty state sits in the middle of the card
export const StyledEmptyState = styled.div(
    ({theme: {spacing}}) => css`
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${spacing * 2}px;
    `
)
